const pageTitle = (title: string) => {
  return `${title} | Insights`;
};

export { pageTitle };
